var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.148 0.968085H7.99307C8.2466 0.968085 8.45082 0.752128 8.45082 0.484043C8.45082 0.215957 8.2466 0 7.99307 0H2.148C1.89448 0 1.69025 0.215957 1.69025 0.484043C1.69025 0.752128 1.89448 0.968085 2.148 0.968085ZM8.6267 2.68085H1.37318C1.11966 2.68085 0.91543 2.4649 0.91543 2.19681C0.91543 1.92873 1.11966 1.71277 1.37318 1.71277H8.6267C8.88022 1.71277 9.08445 1.92873 9.08445 2.19681C9.08445 2.4649 8.88022 2.68085 8.6267 2.68085ZM8.51409 14H1.48592C0.661972 14 0 13.3 0 12.4287V4.99681C0 4.12554 0.661972 3.42554 1.48592 3.42554H8.51409C9.33099 3.42554 10 4.12554 10 4.99681V12.4287C10 13.3 9.33803 14 8.51409 14Z",
    fill: "#010D0E",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.fccf7476aed572d5899a3e3c6388bb1a.svg";
export { ForwardRef as ReactComponent };